var o={toast:100,selectDropDown:40,dialog:30,navbar:20,menu:100,tooltip:1201};export{o as z};
